import { useQuery } from "@tanstack/react-query";

import type { UserRole, UserTier } from "@shared/schemas/enums";

import { apiGet } from "@/lib/api/client";
import { queryKeys } from "@/lib/query/keys";

// ---------------------------------------------------------------------------
// useUsers — Liste aller aktiven User.
// ---------------------------------------------------------------------------
// Quelle fuer den Actor-Filter im Audit-Log-Viewer und fuer die Step-
// Assignment-UI im StepsTab (B8b). Endpoint ist ab B8b fuer alle
// authentifizierten User offen — Felder bleiben minimal.

export interface UserListItem {
  id: string;
  email: string;
  fullName: string;
  role: UserRole;
  tier: UserTier | null;
}

interface UsersResponse {
  ok: true;
  data: UserListItem[];
}

interface UseUsersOptions {
  enabled?: boolean;
}

export function useUsers(options: UseUsersOptions = {}) {
  const { enabled = true } = options;
  return useQuery({
    queryKey: queryKeys.users(),
    queryFn: async (): Promise<UserListItem[]> => {
      const res = await apiGet<UsersResponse>("/api/users");
      return res.data;
    },
    staleTime: 5 * 60_000,
    enabled,
  });
}
